import React from 'react';
import { DonateZelle } from './DonateZelle';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

export const Donate = () => {
  return (
    <div className="site-page">
      <PageHero eyebrow="Support Garden of Peace" title="Donate to Garden of Peace" description="Your donation supports the development and operation of the cemetery." image="/images/Gallery_4.jpg" compact />
      <section className="site-section"><div className="site-container donate-layout">
        <Reveal className="donorbox-card"><p className="site-eyebrow">Online donation</p><h2>Donate Online</h2><iframe src="https://donorbox.org/embed/garden-of-peace-donation" name="donorbox" title="Donate to Garden of Peace" allow="payment" loading="lazy" /></Reveal>
        <Reveal className="donation-info-card" delay={100}><DonateZelle /></Reveal>
      </div></section>
    </div>
);
};
